// extracted by mini-css-extract-plugin
export var downArrow = "_fe-0";
export var infoTooltipIcon = "_fe-3";
export var label = "_fe-1";
export var optionCard = "_fe-4";
export var upArrow = "_fe-2";